import { text_colorTextSecondary } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_md } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const subtitle = css`
  ${font_md};
  color: ${text_colorTextSecondary};
`

export const errorState = css`
  ${font_md};
  color: ${text_colorTextSecondary};
  padding: ${spacing(8)} ${spacing(4)};
  text-align: center;
`
